import { Card, Row, Col, Space, Typography, Button } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import Scheduler from "../../components/Scheduler";
import { appRoutes } from "../../constants/routes";
import Appointment from "../../components/Appointment";
import { AppointmentType } from "../../types/user";
import Answers from "../../components/Answers/answers";
import useCurrentUser from "../../hooks/useCurrentUser";
import PatientAppointments from "../../components/PatientAppointments/patientAppointments";
import { TimeType } from "../../types/scheduler";
import { DATE_FORMAT } from "../../constants/date";

const { Title, Text } = Typography;

const Appointments = () => {
  const [currentAppointment, setCurrentAppointment] =
    useState<AppointmentType | null>(null);
  const navigate = useNavigate();
  const { isDoctor } = useCurrentUser();

  const handleOnClick = (item: TimeType) => {
    if (item.appointment) {
      setCurrentAppointment(item.appointment);
    }
  };

  return isDoctor ? (
    <>
      <Space size={[57, 16]} wrap style={{ marginBottom: 29 }}>
        <Title level={3} style={{ marginBottom: 0 }}>
          I tuoi appuntamenti
        </Title>
        <Button
          type="primary"
          size="large"
          onClick={() => navigate(appRoutes.availability)}
        >
          Gestisci le tue disponibilità
        </Button>
      </Space>
      <Row gutter={[24, 24]}>
        <Col xl={currentAppointment ? 17 : 24} span={24}>
          <Card size="small">
            <Scheduler onTimeClick={handleOnClick} />
          </Card>
        </Col>
        {currentAppointment ? (
          <Col xl={7} span={24}>
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
              <Card>
                <Space size={16} direction="vertical" style={{ width: "100%" }}>
                  <Title level={4} style={{ marginBottom: 0 }}>
                    {currentAppointment.patient?.name}{" "}
                    {currentAppointment.patient?.surname}
                  </Title>
                  <Text type="secondary" style={{ fontSize: 18 }}>
                    {`Paziente iscritto dal ${dayjs(
                      currentAppointment.patient?.created_at
                    ).format(DATE_FORMAT.DAY_MONTH_YEAR)}`}
                  </Text>
                  <Answers patientId={currentAppointment.patient?.id} />
                </Space>
              </Card>
              <Appointment appointment={currentAppointment} vertical />
            </Space>
          </Col>
        ) : null}
      </Row>
    </>
  ) : (
    <PatientAppointments />
  );
};

export default Appointments;
